import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';

import { actions } from '../../services/userProfile';

const styled = withStyles(theme => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center'
    },
    table: {
      backgroundColor: '#fff',
      // maxWidth: 600
    },
    row: {
      '&:hover': {
        backgroundColor: theme.palette.grey[100]
      }
    }
  };
});

class TabInfo extends React.Component {
  tableRow(key, value) {
    return (
      <TableRow className={this.props.classes.row}>
        <TableCell>{key}</TableCell>
        <TableCell align="right">{value}</TableCell>
      </TableRow>
    );
  }

  handleGenderChange = event => {
    this.props.actions.updateData({ gender: event.target.value });
  };

  handleProfileHidden = event => {
    const value = event.target.checked;
    this.props.actions.updateData({ settings: { hidden: value } });
  };

  render() {
    const { classes, data } = this.props;
    return (
      
      <div className={classes.container}>
        <Table className={classes.table}>
          <TableBody>
            <TableRow className={this.props.classes.row}>
              <TableCell>Status</TableCell>
              <TableCell align="right">{data.status}</TableCell>
            </TableRow>

            <TableRow className={this.props.classes.row}>
              <TableCell>Profile Hidden</TableCell>
              <TableCell align="right">
                <Switch
                  checked={data.settings.hidden}
                  onChange={this.handleProfileHidden}
                  color="primary"
                />
              </TableCell>
            </TableRow>

            {this.tableRow('Online', data.online ? 'YES' : 'NO')}
            {this.tableRow(
              'Create Time',
              moment(new Date(data.createTime).toUTCString()).fromNow()
            )}
            {this.tableRow(
              'Update Time',
              moment(new Date(data.updateTime).toUTCString()).fromNow()
            )}
            {this.tableRow(
              'Last Active',
              moment(new Date(data.lastActiveTime).toUTCString()).fromNow()
            )}
            {this.tableRow('First Name', data.firstName)}
            {this.tableRow('Last Name', data.lastName)}
            {this.tableRow('DOB', moment(data.dob).format('MM/DD/YYYY'))}
            {this.tableRow('Email', data.email)}

            <TableRow>
              <TableCell>Gender</TableCell>
              <TableCell align="right">
              <FormControl>
                  <Select
                    value={data.gender}
                    onChange={this.handleGenderChange}
                    inputProps={{
                      name: 'user-gender',
                      id: 'user-gender'
                    }}
                  >
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
            </TableRow>
            {/* {this.tableRow('Gender', data.gender)} */}
            {this.tableRow('Job Title', data.jobTitle)}
            {this.tableRow('Company', data.company)}
            {this.tableRow('School', data.school)}
            {this.tableRow('Photos', data.photos.length)}
            {this.tableRow('Interests', data.interests.length)}
            {this.tableRow('Push Tokens', Object.keys(data.pushTokens).length)}
          </TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.userProfile.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    updateData: data => dispatch(actions.updateData(data))
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(TabInfo))
);
